/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Verdict_Review_TitleInputs */

const cs_import_verdict_review_title = /** @type {(inputs: Import_Verdict_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Než potvrdíte, zkontrolujte`)
};

const en_import_verdict_review_title = /** @type {(inputs: Import_Verdict_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review before commit`)
};

/**
* | output |
* | --- |
* | "Review before commit" |
*
* @param {Import_Verdict_Review_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_verdict_review_title = /** @type {((inputs?: Import_Verdict_Review_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Verdict_Review_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_verdict_review_title(inputs)
	return cs_import_verdict_review_title(inputs)
});